export default ({
  init: () => {
    const module = document.querySelector('.module.donate-footer')
    const inner = module.querySelector('.module-inner')
    module.style.height = inner.innerHeight + 'px'
    module.style.width = '100%'
    inner.style.position = 'fixed'
    inner.style.visibility = 'hidden'
    inner.style.left = 0
    inner.style.bottom = 0
    inner.style.right = 0
    inner.style.transform = 'translateY(100%)'
    inner.style.transitionDuration = '400ms'
    inner.style.transitionPropety = 'transform,visibility'
    inner.style.transitionTimingFunction = 'cubic-bezier(0, 0, .2, 1)'

    setTimeout(() => {
      inner.style.visibility = 'visible'
      inner.style.transform = null
    }, 2000)

    const closeButton = inner.querySelector('.close')
    closeButton.addEventListener('click', e => {
      e.preventDefault()
      module.classList.add('closed')
      inner.style.position = 'relative'
      closeButton.style.display = 'none'
      return false
    })

    window.addEventListener('scroll', () => {
      const moduleRect = module.getBoundingClientRect()
      const innerRect = inner.getBoundingClientRect()

      if (module.classList.contains('closed')) {
        return;
      }

      if (module.classList.contains('static')) {
        if (innerRect.bottom >= window.innerHeight) {
          module.classList.remove('static')
          inner.style.position = 'fixed'
          closeButton.style.display = null
        }
      } else if (moduleRect.top <= innerRect.top) {
        inner.style.position = 'relative'
        closeButton.style.display = 'none'
        module.classList.add('static')
      }
    })
  }
})
